import { SearchableDashboard } from "../constants/searchableDashboards";
import { deleteDataV2, fetchDataV2, postDataV2 } from "./utils";

// GET/POST/DELETE /user_service/favourites are live (docs/needed-endpoints.md §2). `dashboard_id`
// is the dashboard's real numeric id (§1), not its string `key`.
export interface FavouriteDashboard {
  dashboard_id: number;
  created_at: string;
  dashboard: SearchableDashboard;
}

export const getFavouriteDashboards = (): Promise<FavouriteDashboard[]> =>
  fetchDataV2("/user_service/favourites").then((response) => (Array.isArray(response) ? response : []));

// 200 idempotent no-op if already favourited - safe to call without checking first.
//
// Distinct per-dashboard tokenKey (see postDataV2's own comment on this param) - without it, every
// dashboard's add request shared the same cancel-token key (the literal URL, postDataV2's
// default), so favouriting one dashboard while a DIFFERENT dashboard's own add request was still
// in flight cancelled that other request instead of letting it resolve normally. A cancelled
// request resolves to null (handleError's isCancelError branch), which - pushed straight into the
// favourites cache by this hook's onSuccess - crashed every consumer on the next render
// (favourites.map(f => f.dashboard.key) throwing on the null entry). This was the actual mechanism
// behind "clicking several different favourite stars in quick succession crashes the app" - the
// more distinct dashboards favourited in a short window, the more likely two overlap before the
// first's response comes back.
export const addFavouriteDashboard = (dashboardId: number): Promise<FavouriteDashboard> =>
  postDataV2("/user_service/favourites", { dashboard_id: dashboardId }, `favourite-add-${dashboardId}`);

// 204 idempotent no-op if it wasn't favourited - safe to call without checking first.
export const removeFavouriteDashboard = (dashboardId: number): Promise<void> => deleteDataV2(`/user_service/favourites/${dashboardId}`);
